import { useEffect, useContext, useState } from 'react';
import CommonLayout from './common-layout';
import { IAddress } from 'helpers/types';
import DateSelector from 'components/common/date-selector';
import '../../styles/add-edit-workshop-appoitnment.scss';
import { generateSlotHours } from 'helpers/utils';
import InputField from 'components/common/input-field';
import Textarea from 'components/common/textarea-field';
import { useAppDispatch, useAppSelector } from 'hooks/useAppDispatchSelector';
import {
  createWorkshopAppointment,
  editWorkshopAppointment,
  IAddEditWorkshopAppointmentRequest,
  IEditWorkshopAppointmentRequest,
  IMedia,
  IWorkshopAppointmentCustomerData,
  uploadWorkshopMedia,
} from 'store/features/workshopAppointmentsSlice';
import { AppContext } from 'context/app-context';
import Select, { IDefaultOption } from 'components/common/select';
import { usersRoles, initSideModal } from 'helpers/utils';
import { getVehiclesList } from 'store/features/userSlice';
import moment from 'moment';
import CloudUpload from 'components/common/cloud-upload';
import { ReactComponent as CancelIcon } from 'assets/icon/cancel.svg';
import { ReactComponent as PlayIcon } from 'assets/icon/play.svg';
import { setPreviewFileData } from 'store/features/modelSlice';
import { ReactComponent as SearchIcon } from 'assets/icon/search.svg';
import toast from 'react-hot-toast';
import { IUploadImageRequestParam } from 'store/features/organizationSlice';
import { setSideModalData } from 'store/features/modelSlice';
import CheckBox from 'components/common/checkbox';
import {
  IWorkshopAppointmentAddEditData,
  IWorkshopAppointmentVehicleOption,
} from 'interfaces/workshop-appointment-interface';
import { getVehicleAlerts } from 'store/features/vehicleSlice';
import { IVehicleAlertItem } from 'interfaces/vehicle-interface';
import { useTranslation } from 'react-i18next';

export interface IAddEditOtherStation extends IAddress {
  isEdited?: boolean;
  index: number;
}
interface IError {
  alert_id?: string;
  vehicle_id?: string;
  other_service_type?: string;
  service_description?: string;
}

export interface IUploadMediaResponse {
  key: string;
  url: string;
  download_url: string;
}

const initWorkShopAppointmentDetails: IWorkshopAppointmentAddEditData = {
  service_description: '',
  other_service_type: '',
  special_note: '',
  user_id: '',
  user_details: null,
  vehicle_id: '',
  appointment_date: moment().toString(),
  time: '',
  replace_car: false,
  alert_id: '',
};

const AddEditWorkshopAppointment = () => {
  const { setLoader } = useContext(AppContext);
  const dispatch = useAppDispatch();
  const { workshopAppointmentDetails, vehicles } = useAppSelector(
    state => state.workShopAppointment,
  );
  const { selectedOrganization } = useAppSelector(state => state.auth);
  const { users } = useAppSelector(state => state.user);
  const { selectedVehicleALerts } = useAppSelector(state => state.vehicles);
  const { t } = useTranslation();
  const {
    sideModal: {
      content: { callBackFun, formFor },
    },
  } = useAppSelector(state => state.modal);
  const [dropdownSearch, setDropdownSearch] = useState<string>('');
  const [files, setFiles] = useState<File[]>([]);
  const [error, setError] = useState<IError>({});
  const [workShopAppointment, setWorkshopAppointment] = useState<IWorkshopAppointmentAddEditData>(
    initWorkShopAppointmentDetails,
  );
  const [selectedVehicle, setSelectedVehicle] = useState<IWorkshopAppointmentVehicleOption | null>(
    null,
  );
  const [vehiclesOptions, setVehiclesOptions] = useState<IDefaultOption[]>([]);
  const [alertsList, setAlertList] = useState<IDefaultOption[]>([]);

  const slots = generateSlotHours() || [];

  const fetchVehiclesList = async () => {
    let params = {};
    if (selectedOrganization?.role_name === usersRoles.DEALER_ADMIN) {
      params = {
        organization_id: selectedOrganization?.organization_id,
      };
    }
    const response = await dispatch(
      getVehiclesList({ params: { ...params, is_from_book_workshop: true } }),
    )
      .then(() => setLoader(false))
      .catch(() => setLoader(false));
    return response;
  };
  const setWorkshopAppointmentData = () => {
    try {
      if (workshopAppointmentDetails) {
        const updatedWorkshopAppointmentData: IWorkshopAppointmentAddEditData = {
          _id: workshopAppointmentDetails?._id || '',
          alert_id:
            (workshopAppointmentDetails?.other_service_type
              ? 'OTHER'
              : workshopAppointmentDetails?.alert_details?._id) || '',
          other_service_type: workshopAppointmentDetails?.other_service_type || '',
          service_description: workshopAppointmentDetails?.service_description || '',
          special_note: workshopAppointmentDetails?.special_note || '',
          user_id: workshopAppointmentDetails?.user_id || '',
          user_details: workshopAppointmentDetails?.user_details || null,
          vehicle_id: workshopAppointmentDetails?.vehicle_id || '',
          appointment_date: workshopAppointmentDetails?.slot?.date || '',
          time: workshopAppointmentDetails?.slot?.time || '',
          media: workshopAppointmentDetails?.media,
          replace_car: workshopAppointmentDetails?.replace_car,
        };
        setWorkshopAppointment(updatedWorkshopAppointmentData);
      }
    } catch (error) {
      setLoader(false);
    }
  };
  const fetchData = async () => {
    try {
      await fetchVehiclesList();
    } catch (error) {
      setLoader(false);
    }
  };
  useEffect(() => {
    try {
      setLoader(true);
      fetchData();
      if (formFor === 'EDIT') {
        setWorkshopAppointmentData();
      }
      setLoader(false);
    } catch (error) {
      setLoader(false);
    }
  }, []);
  useEffect(() => {
    try {
      setLoader(true);
      const updatedOptions: IDefaultOption[] = (vehicles || []).map(data => ({
        id: data?._id || '',
        name: `${data?.model} (${data?.plate})` || '',
        value: data?.plate || '',
      }));
      if (workShopAppointment?.vehicle_id && !selectedVehicle) {
        const vehicleSel =
          vehicles.find(data => data?._id === workShopAppointment?.vehicle_id) || null;
        setSelectedVehicle(vehicleSel);
      }
      setVehiclesOptions(updatedOptions);
      setLoader(false);
    } catch (error) {
      setLoader(false);
    }
  }, [vehicles]);
  const setVehicleData = async () => {
    try {
      if (workShopAppointment?.vehicle_id) {
        setLoader(true);
        const respponse: IVehicleAlertItem[] = await dispatch(
          getVehicleAlerts({
            vehicle_id: workShopAppointment?.vehicle_id,
            params: { status: 'alert' },
          }),
        ).catch(() => setLoader(false));
        const formatedOption = respponse.map(data => ({
          id: data?._id,
          _id: data?._id,
          name: data?.alert_ref ? `${data?.alert_ref} ${data?.title}` : data?.title,
          value: data?._id,
        }));
        const selVehicle: IWorkshopAppointmentVehicleOption | null =
          (vehicles || []).find(data => data?._id === workShopAppointment?.vehicle_id) || null;
        setAlertList([
          ...formatedOption,
          { id: 'OTHER', _id: 'OTHER', name: 'Other', value: 'OTHER' },
        ]);
        setSelectedVehicle(selVehicle || null);
        setWorkshopAppointment({ ...workShopAppointment });
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
    }
  };
  useEffect(() => {
    setVehicleData();
  }, [users, workShopAppointment?.vehicle_id]);
  useEffect(() => {
    try {
      setLoader(true);
      const selectedVehicleData: IWorkshopAppointmentVehicleOption | null =
        vehicles?.find(data => data?._id === workShopAppointment?.vehicle_id) || null;
      setSelectedVehicle(selectedVehicleData);
      setLoader(false);
    } catch (error) {
      setLoader(false);
    }
  }, [workShopAppointment?.vehicle_id]);
  const handleChange = (
    field: string,
    value: string | IWorkshopAppointmentCustomerData | null | boolean,
  ) => {
    if (field === 'slot') {
      setWorkshopAppointment({
        ...workShopAppointment,
        time: String(value) || '',
      });
    } else {
      setWorkshopAppointment({ ...workShopAppointment, [field]: value });
    }
  };
  const getErrorData = () => {
    return {
      alert_id: !workShopAppointment?.alert_id?.trim()
        ? t('workshopAppointment.add_edit.error_alert_toast_message')
        : '',
      vehicle_id: !workShopAppointment?.vehicle_id?.trim()
        ? t('workshopAppointment.add_edit.error_customer_toast_message')
        : '',
      service_description: !workShopAppointment?.service_description?.trim()
        ? t('workshopAppointment.add_edit.error_service_description')
        : '',
    };
  };
  const isValid = () => {
    if (
      !workShopAppointment?.alert_id?.trim() ||
      !workShopAppointment?.vehicle_id?.trim() ||
      !workShopAppointment?.service_description?.trim()
    ) {
      const output = getErrorData();
      setError(output);
      return false;
    } else if (
      workShopAppointment?.alert_id === 'OTHER' &&
      !workShopAppointment?.other_service_type?.trim()
    ) {
      setError({
        ...error,
        other_service_type: !workShopAppointment?.other_service_type?.trim()
          ? t('workshopAppointment.add_edit.error_other_service_toast_message')
          : '',
      });
      return false;
    } else {
      const output = getErrorData();
      setError(output);
      return true;
    }
  };
  const uploadMediaForAdd = async () => {
    try {
      const uploadMediaParam =
        files.map(data => {
          return {
            request: {
              file_name: data?.name || '',
              file_type: data?.type || '',
              file_size: data?.size || 0,
            },
            file: data,
          };
        }) || [];
      const mediaResponse: IUploadMediaResponse[] = await Promise.all(
        [...uploadMediaParam].map(data => {
          const params: IUploadImageRequestParam = {
            request: {
              file_name: data?.request?.file_name || '',
              file_type: data?.request?.file_type || '',
              file_size: data?.request?.file_size || 0,
            },
            file: data?.file,
          };
          const res = dispatch(uploadWorkshopMedia({ params }));
          return res;
        }),
      );
      return Promise.resolve(mediaResponse);
    } catch (error) {
      return Promise.reject(error);
    }
  };
  const getRequestData = async () => {
    const uploadMedia = await uploadMediaForAdd().catch(err => {
      return;
    });
    let request: IAddEditWorkshopAppointmentRequest = {
      service_description: workShopAppointment?.service_description || '',
      media: uploadMedia?.length ? uploadMedia.map(data => data?.key || '') : [],
      vehicle_id: workShopAppointment?.vehicle_id || '',
      replace_car: workShopAppointment?.replace_car,
      type: selectedOrganization?.role_name || '',
      organization_id: selectedVehicle?.user_role_data?.organization_id || '',
      parking_id: selectedVehicle?.vehicle_data?.parking_id || '',
      time: workShopAppointment?.time || '',
      date: moment(workShopAppointment?.appointment_date).format('DD/MM/YYYY') || '',
      user_id: selectedVehicle?.user_data?._id || '',
    };
    if (workShopAppointment?.alert_id === 'OTHER') {
      request = { ...request, other_service_type: workShopAppointment?.other_service_type || '' };
    } else {
      request = { ...request, alert_id: workShopAppointment?.alert_id || '' };
    }
    if (workShopAppointment?.special_note) {
      request = { ...request, special_note: workShopAppointment?.special_note || '' };
    }
    return request;
  };
  const handleCreateWorkshopAppointment = async () => {
    try {
      setLoader(true);
      const request = await getRequestData();
      dispatch(createWorkshopAppointment({ request: { ...request } }))
        .then(() => {
          callBackFun && callBackFun();
          toast.success(
            t('workshopAppointment.add_edit.success_appointment_created_toast_message'),
          );
          dispatch(setSideModalData(initSideModal));
          setLoader(false);
        })
        .catch(() => {
          setLoader(false);
        });
    } catch (error) {
      setLoader(false);
    }
  };
  const handleEditWorkshopAppointment = async () => {
    try {
      setLoader(true);
      let request: IEditWorkshopAppointmentRequest = await getRequestData();
      request = {
        ...request,
        slot_id: workshopAppointmentDetails?.slot_id || '',
        status: workshopAppointmentDetails?.status || '',
      };
      delete request.type;
      if (workShopAppointment?.media?.length) {
        const workshopMedia = workShopAppointment?.media.map(data => data?.key) || [];
        request = { ...request, media: [...request?.media, ...workshopMedia] };
      }
      dispatch(
        editWorkshopAppointment({
          request: { ...request },
          appointment_id: workShopAppointment?._id || '',
        }),
      )
        .then(() => {
          callBackFun && callBackFun();
          toast.success(
            t('workshopAppointment.add_edit.success_appointment_updated_toast_message'),
          );
          dispatch(setSideModalData(initSideModal));
          setLoader(false);
        })
        .catch(() => {
          setLoader(false);
        });
    } catch (error) {
      setLoader(false);
    }
  };
  const handleSubmit = () => {
    try {
      if (!workShopAppointment?.appointment_date?.trim() || !workShopAppointment?.time?.trim()) {
        toast.error(t('workshopAppointment.add_edit.error_appointment_toast_message'));
        return;
      }
      if (!isValid()) {
        return;
      }
      formFor === 'EDIT' ? handleEditWorkshopAppointment() : handleCreateWorkshopAppointment();
    } catch (error) {}
  };
  const handlePreviewFile = (file: File, type: string) => {
    dispatch(
      setPreviewFileData({
        type: type || '',
        content: { url: window.URL.createObjectURL(file) },
      }),
    );
  };
  const getFileContent = (file: File) => {
    const splitedVal = file.type.split('/');
    switch (splitedVal[0]) {
      case 'image':
        return (
          <img
            src={window.URL.createObjectURL(file)}
            className="flex items-center justify-center min-w-full h-full w-12 object-contain"
            alt=""
            onClick={() => handlePreviewFile(file, splitedVal[0])}
          />
        );
      case 'video':
        return (
          <div
            className="flex items-center justify-center bg-grey3 w-12 h-full min-w-full rounded-3 cursor-pointer"
            onClick={() => handlePreviewFile(file, splitedVal[0])}
          >
            <PlayIcon />
          </div>
        );
      default:
        return (
          <div
            className="flex items-center justify-center bg-grey1 w-full h-full rounded-3 cursor-pointer"
            onClick={() => handlePreviewFile(file, splitedVal[0])}
          >
            <SearchIcon />
          </div>
        );
    }
  };
  const getAddedFileContent = (file: IMedia) => {
    const splitedVal = file.type.split('/');
    const handleShowFile = () => {
      dispatch(
        setPreviewFileData({
          type: file.type || '',
          content: { url: file.url },
        }),
      );
    };
    switch (splitedVal[0]) {
      case 'image':
        return (
          <img
            src={file.url}
            className="flex items-center justify-center min-w-full h-full w-12 object-contain"
            alt=""
            onClick={() => handleShowFile()}
          />
        );
      case 'video':
        return (
          <div
            className="flex items-center justify-center bg-grey3 w-12 h-full min-w-full rounded-3 cursor-pointer"
            onClick={() => handleShowFile()}
          >
            <PlayIcon />
          </div>
        );
      default:
        return (
          <div
            className="flex items-center justify-center bg-grey1 w-full h-full rounded-3 cursor-pointer"
            onClick={() => handleShowFile()}
          >
            <SearchIcon />
          </div>
        );
    }
  };
  const handleSetFiles = (file: File) => {
    const updatedFiles = [...files, file];
    setFiles(updatedFiles);
  };
  const handleRemoveFiles = (index: number) => {
    const updatedFiles = (files || []).filter((file, i) => i !== index);
    setFiles(updatedFiles);
  };
  return (
    <CommonLayout
      onConfirm={() => handleSubmit()}
      confirmButtonProps={{ label: t('workshopAppointment.add_edit.schedule') }}
    >
      <div
        className={`flex flex-col w-full h-full p-6 ${
          selectedOrganization?.role_name === usersRoles?.FLEET_MANAGE ? 'pointer-events-none' : ''
        }`}
      >
        <div className="flex flex-wrap -mx-3">
          <div className="flex w-1/2 pr-1 flex-wrap h-fit">
            <div className="w-full px-3">
              <CloudUpload
                setFile={e => {
                  if (e?.target?.files?.length) {
                    handleSetFiles(e?.target?.files[0]);
                  } else {
                    e.stopPropagation();
                  }
                }}
                acceptedFile={'image/*,video/*'}
                title={t('FILE_TITLE')}

              />
            </div>
            <div className="w-full flex items-center justify-start px-3 mt-3 overflow-hidden">
              <div className="overflow-x-auto w-full max-w-full flex py-2">
                {workShopAppointment?.media?.length ? (
                  workShopAppointment?.media.map((file, index) => (
                    <div
                      className="flex items-center justify-center ml-2 rounded-3 h-12 w-12 max-w-12 min-h-full min-w-fit bg-grey1 relative"
                      key={`${file._id}-${index}`}
                    >
                      <CancelIcon
                        className="flex absolute -top-1 -right-1 cursor-pointer"
                        onClick={() => {
                          const updatedMediaFile = workShopAppointment?.media?.filter(
                            data => data?._id !== file?._id,
                          );
                          setWorkshopAppointment({
                            ...workShopAppointment,
                            media: updatedMediaFile,
                          });
                        }}
                      />
                      {getAddedFileContent(file)}
                    </div>
                  ))
                ) : (
                  <></>
                )}
                {files && files?.length ? (
                  files.map((file, index) => (
                    <div
                      className="flex items-center justify-center ml-2 rounded-3 h-12 w-12 max-w-12 min-h-full min-w-fit bg-grey1 relative"
                      key={`${file?.name}-${index}`}
                    >
                      <CancelIcon
                        className="flex absolute -top-1 -right-1 cursor-pointer"
                        onClick={() => handleRemoveFiles(index)}
                      />
                      {getFileContent(file)}
                    </div>
                  ))
                ) : (
                  <></>
                )}
              </div>
            </div>
            <div className="w-full mt-2 px-3 mb-3">
              <label className="text-base font-bold">
                {t('workshopAppointment.add_edit.title')}
              </label>
            </div>
            <div className="w-full px-3">
              <div className="mb-3">
                <label className="font-medium text-sm text-black2 w-full">
                  {t('workshopAppointment.add_edit.vehicle')}
                </label>
                <Select
                  placeholder={t('workshopAppointment.add_edit.placeholder_vehicle')}
                  options={vehiclesOptions.filter(
                    coun =>
                      coun?.value &&
                      coun?.value.toLowerCase().includes(dropdownSearch.toLowerCase()),
                  )}
                  selected={
                    vehiclesOptions?.find(data => data?.id === workShopAppointment?.vehicle_id) ||
                    null
                  }
                  setSelected={data => handleChange('vehicle_id', data?.id)}
                  disabled={false}
                  error={error?.vehicle_id}
                  isSearchable
                  removeSearchOnBlur
                  search={dropdownSearch}
                  setSearch={val => setDropdownSearch(val)}
                />
              </div>
            </div>
            <div className="w-full px-3">
              <div className="mb-3">
                <label className="font-medium text-sm text-black2 w-full">
                  {t('workshopAppointment.add_edit.alert')}
                </label>
                <Select
                  placeholder={t('workshopAppointment.add_edit.placeholder_alert')}
                  options={alertsList.filter(
                    coun => coun?.name.toLowerCase().startsWith(dropdownSearch.toLowerCase()),
                  )}
                  selected={
                    alertsList?.find(data => data?.id === workShopAppointment?.alert_id) || null
                  }
                  setSelected={data => {
                    const selAlert = selectedVehicleALerts.find(
                      a => a._id === (data?._id || data?.id),
                    );
                    setWorkshopAppointment({
                      ...workShopAppointment,
                      alert_id: data?._id || data?.id,
                      service_description: selAlert ? selAlert?.description : '',
                    });
                  }}
                  disabled={!workShopAppointment?.vehicle_id}
                  error={error?.alert_id || ''}
                  isSearchable
                  removeSearchOnBlur
                  search={dropdownSearch}
                  setSearch={val => setDropdownSearch(val)}
                />
              </div>
            </div>
            {workShopAppointment?.alert_id === 'OTHER' && (
              <div className="w-full px-3">
                <div className="mb-3">
                  <label className="font-medium text-sm text-black2 w-full">
                    {t('workshopAppointment.add_edit.service_type')}
                  </label>
                  <InputField
                    placeholder={t('workshopAppointment.add_edit.placeholder_service_type')}
                    value={workShopAppointment?.other_service_type || ''}
                    onChange={val => handleChange('other_service_type', val)}
                    error={error?.other_service_type || ''}
                  />
                </div>
              </div>
            )}
            <div className="w-full px-3">
              <div className="mb-3">
                <label className="font-medium text-sm text-black2 w-full">
                  {t('workshopAppointment.add_edit.service_description')}
                </label>
                <Textarea
                  placeholder={t('workshopAppointment.add_edit.service_description')}
                  value={workShopAppointment?.service_description}
                  onChange={val => handleChange('service_description', val)}
                  error={error?.service_description || ''}
                />
              </div>
            </div>
            <div className="w-full px-3">
              <div className="mb-3">
                <label className="font-medium text-sm text-black2 w-full">
                  {t('workshopAppointment.add_edit.customer')}
                </label>
                <InputField
                  placeholder={t('workshopAppointment.add_edit.placeholder_customer')}
                  value={
                    selectedVehicle?.user_data?.name && selectedVehicle?.user_data?.surname
                      ? `${selectedVehicle?.user_data?.name} ${selectedVehicle?.user_data?.surname}`
                      : ''
                  }
                  onChange={val => {}}
                  error={''}
                  disabled
                />
              </div>
            </div>
            <div className="w-full px-3">
              <div className="mb-3">
                <label className="font-medium text-sm text-black2 w-full">
                  {t('workshopAppointment.ExpandedUi.customer_email')}
                </label>
                <InputField
                  placeholder={t('workshopAppointment.add_edit.placeholder_email')}
                  value={selectedVehicle?.user_data?.email || ''}
                  onChange={val => {}}
                  error={''}
                  disabled
                />
              </div>
            </div>
            <div className="w-1/2 px-3">
              <div className="mb-3">
                <label className="font-medium text-sm text-black2 w-full">
                  {t('workshopAppointment.add_edit.phone')}
                </label>
                <InputField
                  placeholder={t('workshopAppointment.add_edit.phone')}
                  value={
                    selectedVehicle?.user_data?.country_code &&
                    selectedVehicle?.user_data?.mobile_no
                      ? `+${
                          selectedVehicle?.user_data?.country_code
                            ? selectedVehicle?.user_data?.country_code.replaceAll('+', '')
                            : ''
                        } ${selectedVehicle?.user_data?.mobile_no || ''}`
                      : ''
                  }
                  onChange={val => {}}
                  error={''}
                  disabled
                />
              </div>
            </div>
            <div className="w-1/2 px-3">
              <div className="mb-3">
                <label className="font-medium text-sm text-black2 w-full">
                  {t('workshopAppointment.ExpandedUi.vehicle_plate')}
                </label>
                <InputField
                  placeholder={t('workshopAppointment.ExpandedUi.vehicle_plate')}
                  value={selectedVehicle?.plate || ''}
                  onChange={val => {}}
                  error={''}
                  disabled
                />
              </div>
            </div>
            <div className="w-full px-3">
              <div className="mb-3">
                <label className="font-medium text-sm text-black2 w-full">
                  {t('workshopAppointment.add_edit.note')}
                </label>
                <Textarea
                  placeholder={t('workshopAppointment.add_edit.placeholder_note')}
                  value={workShopAppointment?.special_note || ''}
                  onChange={val => handleChange('special_note', val)}
                />
              </div>
            </div>
            <div className="w-full px-3">
              <div className="flex items-center mb-3 gap-x-2">
                <div className="flex items-center justify-center">
                  <CheckBox
                    checked={workShopAppointment?.replace_car}
                    onChange={checked => handleChange('replace_car', checked)}
                    disabled={selectedOrganization?.role_name === usersRoles.FLEET_MANAGE}
                  />
                </div>
                <label className="text-sm font-medium flex-1">
                  {t('workshopAppointment.add_edit.replace_Car')}
                </label>
              </div>
            </div>
          </div>
          <div className="flex w-1/2 flex-wrap pl-1 h-fit">
            <label className="text-lg font-semibold w-full">
              {t('workshopAppointment.add_edit.appointment_timeslot')}
            </label>
            <div className="w-full flex">
              <DateSelector
                showCurrentMonth={!workShopAppointment?.appointment_date}
                disablePastDays
                startDate={moment.unix(
                  workShopAppointment?.appointment_date
                    ? moment(workShopAppointment?.appointment_date).unix()
                    : moment().unix(),
                )}
                setStartDate={data => handleChange('appointment_date', data)}
              />
            </div>
            <div className="flex w-full flex-wrap pl-6 pr-10 mt-4">
              {slots.map(data => (
                <div
                  className="flex items-center justify-center w-1/5 px-1 py-1 cursor-pointer"
                  onClick={() => handleChange('slot', data)}
                >
                  <div
                    className={`flex items-center justify-center- w-full px-1 py-1 rounded-2 ${
                      workShopAppointment?.time === data ? 'bg-primary' : 'bg-bg-50'
                    }`}
                  >
                    <label
                      className={`text-sm  font-semibold mx-auto cursor-pointer ${
                        workShopAppointment?.time === data ? 'text-white' : 'text-primary'
                      }`}
                    >
                      {data}
                    </label>
                  </div>
                </div>
              ))}
            </div>
            <div className="flex w-full flex-wrap pl-6 pr-10 mt-4">
              <label className="text-base font-semibold w-full">
                {t('workshopAppointment.add_edit.appointment_date')}
              </label>
              <label className="text-base text-grey9 font-semibold w-full">
                {workShopAppointment?.appointment_date
                  ? `${moment(workShopAppointment?.appointment_date).format('DD')} ${t(
                      'months.' + moment(workShopAppointment?.appointment_date).format('MMMM'),
                    )}, ${moment(workShopAppointment?.appointment_date).format(
                      'YYYY',
                    )} at ${workShopAppointment?.time}`
                  : '-'}
              </label>
            </div>
          </div>
        </div>
      </div>
    </CommonLayout>
  );
};

export default AddEditWorkshopAppointment;
